import { RaterNominationDetails } from '../interfaces/RaterNominationDetails';

export const SET_RATER_NOMINATION_DETAILS = 'SET_RATER_NOMINATION_DETAILS';
export const SET_RATING_ID = 'SET_RATING_ID';
export const SET_NEW_ADDED_RATER_ID = 'SET_NEW_ADDED_RATER_ID';

interface SetRaterNominationDetailsAction {
  type: typeof SET_RATER_NOMINATION_DETAILS;
  payload: RaterNominationDetails;
}

interface SetRatingIdAction {
  type: typeof SET_RATING_ID;
  payload: string;
}

interface SetNewAddedRaterIdAction {
  type: typeof SET_NEW_ADDED_RATER_ID;
  payload: string;
}

export type MfsStoreAction = SetRaterNominationDetailsAction | SetRatingIdAction | SetNewAddedRaterIdAction;
